module.exports = ".chart-div-class {\n  width: 100%;\n  height: 100px;\n  display: block;\n}\n"